import {useMutation} from "@apollo/client";
import {
  AddArticleCommentDocument,
  AddArticleCommentInput
} from "generated/graphql";

export const useAddArticleComment = () => {
  const [mutate] = useMutation(AddArticleCommentDocument, {
    update(cache, { data }) {
      const ev = data?.addArticleComment.event;
      if (!ev) return;
      cache.modify({
        id: `Article:${ev.articleId}`,
        fields: {
          events: (existing: readonly any[]) => [ev, ...existing]
        }
      })
    }
  });

  return (input: AddArticleCommentInput) => mutate({ variables: { input }});
}